import React from 'react';
import { arrayOf, element, func, shape, string } from 'prop-types';
import { Dropdown, Link } from '../../../../atoms';

const SignedUserState = ({
  username,
  welcomeMessage,
  logoutMessage,
  signOutUrl,
  menuLinks = [],
  onLogout,
  handleSignedHover,
  handleSignedMenuClick
}) => {
  return /*#__PURE__*/React.createElement(Dropdown, {
    mouseenter: true,
    pointing: true
  }, /*#__PURE__*/React.createElement(Dropdown.Title, {
    color: "text.white",
    fill: "background.lighter",
    onMouseEnter: handleSignedHover
  }, welcomeMessage || /*#__PURE__*/React.createElement("span", null, "Ol\xE1, ", /*#__PURE__*/React.createElement("b", null, username))), /*#__PURE__*/React.createElement(Dropdown.Menu, {
    pointing: true,
    fontSize: 0,
    p: 2
  }, menuLinks.map(({
    icon,
    label,
    url
  }, i) => /*#__PURE__*/React.createElement(Dropdown.Item, {
    key: i,
    startIcon: icon,
    p: 1,
    my: 2
  }, /*#__PURE__*/React.createElement(Link, {
    onClick: () => handleSignedMenuClick(label),
    href: url,
    fontSize: 0,
    "data-testid": `link-${i}`
  }, label))), /*#__PURE__*/React.createElement(Dropdown.Divider, null), /*#__PURE__*/React.createElement(Dropdown.Item, {
    p: 1,
    my: 2,
    disableHover: true
  }, logoutMessage || `Não é ${username}? `, /*#__PURE__*/React.createElement(Link, {
    underline: true,
    px: 0,
    fontSize: 0,
    href: signOutUrl,
    onClick: () => {
      onLogout();
      handleSignedMenuClick('sair');
    },
    "data-testid": "link-logout"
  }, "Sair"))));
};

process.env.NODE_ENV !== "production" ? SignedUserState.propTypes = {
  username: string.isRequired,
  welcomeMessage: string,
  logoutMessage: string,
  menuLinks: arrayOf(shape({
    icon: element,
    label: string.isRequired,
    url: string.isRequired
  })),
  signOutUrl: string,
  onLogout: func.isRequired,
  handleSignedHover: () => {},
  handleSignedMenuClick: () => {}
} : void 0;
SignedUserState.defaultProps = {
  welcomeMessage: '',
  logoutMessage: '',
  signOutUrl: '',
  handleSignedHover: () => {},
  handleSignedMenuClick: () => {}
};
export default SignedUserState;